/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LegacyRouteImport } from './routes/legacy'
import { Route as HubRouteRouteImport } from './routes/_hub/route'
import { Route as HubIndexRouteImport } from './routes/_hub/index'
import { Route as HubCustomerIdRouteRouteImport } from './routes/_hub/$customerId/route'
import { Route as HubCustomerIdIndexRouteImport } from './routes/_hub/$customerId/index'
import { Route as PulseSurveysParticipantIdRouteImport } from './routes/pulse/surveys.$participantId'
import { Route as HubCustomerIdDashboardRouteRouteImport } from './routes/_hub/$customerId/dashboard/route'
import { Route as HubCustomerIdDashboardIndexRouteImport } from './routes/_hub/$customerId/dashboard/index'
import { Route as HubCustomerIdDashboardListsRouteImport } from './routes/_hub/$customerId/dashboard/lists'
import { Route as HubCustomerIdDashboardAnnualCycleRouteImport } from './routes/_hub/$customerId/dashboard/annual-cycle'
import { Route as HubCustomerIdPulsePulseIdRouteRouteImport } from './routes/_hub/$customerId/pulse/$pulseId/route'
import { Route as HubCustomerIdDashboardProfileIdRouteRouteImport } from './routes/_hub/$customerId/dashboard/$profileId/route'
import { Route as HubCustomerIdPulsePulseIdIndexRouteImport } from './routes/_hub/$customerId/pulse/$pulseId/index'
import { Route as HubCustomerIdDashboardProfileIdIndexRouteImport } from './routes/_hub/$customerId/dashboard/$profileId/index'
import { Route as HubCustomerIdDashboardProfileIdListsRouteImport } from './routes/_hub/$customerId/dashboard/$profileId/lists'
import { Route as HubCustomerIdDashboardProfileIdAnnualCycleRouteImport } from './routes/_hub/$customerId/dashboard/$profileId/annual-cycle'
import { Route as HubCustomerIdPulsePulseIdSurveyListSurveysRouteImport } from './routes/_hub/$customerId/pulse/$pulseId/_surveyList/surveys'
import { Route as HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRouteImport } from './routes/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/route'
import { Route as HubCustomerIdPulsePulseIdSurveysSurveyIdIndexRouteImport } from './routes/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/index'
import { Route as HubCustomerIdPulsePulseIdSurveysSurveyIdEditRouteImport } from './routes/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/edit'

const LegacyRoute = LegacyRouteImport.update({
  id: '/legacy',
  path: '/legacy',
  getParentRoute: () => rootRouteImport,
} as any)
const HubRouteRoute = HubRouteRouteImport.update({
  id: '/_hub',
  getParentRoute: () => rootRouteImport,
} as any)
const HubIndexRoute = HubIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HubRouteRoute,
} as any)
const HubCustomerIdRouteRoute = HubCustomerIdRouteRouteImport.update({
  id: '/$customerId',
  path: '/$customerId',
  getParentRoute: () => HubRouteRoute,
} as any)
const HubCustomerIdIndexRoute = HubCustomerIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HubCustomerIdRouteRoute,
} as any)
const PulseSurveysParticipantIdRoute =
  PulseSurveysParticipantIdRouteImport.update({
    id: '/pulse/surveys/$participantId',
    path: '/pulse/surveys/$participantId',
    getParentRoute: () => rootRouteImport,
  } as any)
const HubCustomerIdDashboardRouteRoute =
  HubCustomerIdDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => HubCustomerIdRouteRoute,
  } as any)
const HubCustomerIdDashboardIndexRoute =
  HubCustomerIdDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => HubCustomerIdDashboardRouteRoute,
  } as any)
const HubCustomerIdDashboardListsRoute =
  HubCustomerIdDashboardListsRouteImport.update({
    id: '/lists',
    path: '/lists',
    getParentRoute: () => HubCustomerIdDashboardRouteRoute,
  } as any)
const HubCustomerIdDashboardAnnualCycleRoute =
  HubCustomerIdDashboardAnnualCycleRouteImport.update({
    id: '/annual-cycle',
    path: '/annual-cycle',
    getParentRoute: () => HubCustomerIdDashboardRouteRoute,
  } as any)
const HubCustomerIdPulsePulseIdRouteRoute =
  HubCustomerIdPulsePulseIdRouteRouteImport.update({
    id: '/pulse/$pulseId',
    path: '/pulse/$pulseId',
    getParentRoute: () => HubCustomerIdRouteRoute,
  } as any)
const HubCustomerIdDashboardProfileIdRouteRoute =
  HubCustomerIdDashboardProfileIdRouteRouteImport.update({
    id: '/$profileId',
    path: '/$profileId',
    getParentRoute: () => HubCustomerIdDashboardRouteRoute,
  } as any)
const HubCustomerIdPulsePulseIdIndexRoute =
  HubCustomerIdPulsePulseIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => HubCustomerIdPulsePulseIdRouteRoute,
  } as any)
const HubCustomerIdDashboardProfileIdIndexRoute =
  HubCustomerIdDashboardProfileIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => HubCustomerIdDashboardProfileIdRouteRoute,
  } as any)
const HubCustomerIdDashboardProfileIdListsRoute =
  HubCustomerIdDashboardProfileIdListsRouteImport.update({
    id: '/lists',
    path: '/lists',
    getParentRoute: () => HubCustomerIdDashboardProfileIdRouteRoute,
  } as any)
const HubCustomerIdDashboardProfileIdAnnualCycleRoute =
  HubCustomerIdDashboardProfileIdAnnualCycleRouteImport.update({
    id: '/annual-cycle',
    path: '/annual-cycle',
    getParentRoute: () => HubCustomerIdDashboardProfileIdRouteRoute,
  } as any)
const HubCustomerIdPulsePulseIdSurveyListSurveysRoute =
  HubCustomerIdPulsePulseIdSurveyListSurveysRouteImport.update({
    id: '/_surveyList/surveys',
    path: '/surveys',
    getParentRoute: () => HubCustomerIdPulsePulseIdRouteRoute,
  } as any)
const HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRoute =
  HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRouteImport.update({
    id: '/surveys/$surveyId',
    path: '/surveys/$surveyId',
    getParentRoute: () => HubCustomerIdPulsePulseIdRouteRoute,
  } as any)
const HubCustomerIdPulsePulseIdSurveysSurveyIdIndexRoute =
  HubCustomerIdPulsePulseIdSurveysSurveyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRoute,
  } as any)
const HubCustomerIdPulsePulseIdSurveysSurveyIdEditRoute =
  HubCustomerIdPulsePulseIdSurveysSurveyIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/legacy': typeof LegacyRoute
  '/$customerId': typeof HubCustomerIdRouteRouteWithChildren
  '/': typeof HubIndexRoute
  '/$customerId/dashboard': typeof HubCustomerIdDashboardRouteRouteWithChildren
  '/pulse/surveys/$participantId': typeof PulseSurveysParticipantIdRoute
  '/$customerId/': typeof HubCustomerIdIndexRoute
  '/$customerId/dashboard/$profileId': typeof HubCustomerIdDashboardProfileIdRouteRouteWithChildren
  '/$customerId/pulse/$pulseId': typeof HubCustomerIdPulsePulseIdRouteRouteWithChildren
  '/$customerId/dashboard/annual-cycle': typeof HubCustomerIdDashboardAnnualCycleRoute
  '/$customerId/dashboard/lists': typeof HubCustomerIdDashboardListsRoute
  '/$customerId/dashboard/': typeof HubCustomerIdDashboardIndexRoute
  '/$customerId/dashboard/$profileId/annual-cycle': typeof HubCustomerIdDashboardProfileIdAnnualCycleRoute
  '/$customerId/dashboard/$profileId/lists': typeof HubCustomerIdDashboardProfileIdListsRoute
  '/$customerId/dashboard/$profileId/': typeof HubCustomerIdDashboardProfileIdIndexRoute
  '/$customerId/pulse/$pulseId/': typeof HubCustomerIdPulsePulseIdIndexRoute
  '/$customerId/pulse/$pulseId/surveys/$surveyId': typeof HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRouteWithChildren
  '/$customerId/pulse/$pulseId/surveys': typeof HubCustomerIdPulsePulseIdSurveyListSurveysRoute
  '/$customerId/pulse/$pulseId/surveys/$surveyId/edit': typeof HubCustomerIdPulsePulseIdSurveysSurveyIdEditRoute
  '/$customerId/pulse/$pulseId/surveys/$surveyId/': typeof HubCustomerIdPulsePulseIdSurveysSurveyIdIndexRoute
}
export interface FileRoutesByTo {
  '/legacy': typeof LegacyRoute
  '/': typeof HubIndexRoute
  '/pulse/surveys/$participantId': typeof PulseSurveysParticipantIdRoute
  '/$customerId': typeof HubCustomerIdIndexRoute
  '/$customerId/dashboard/annual-cycle': typeof HubCustomerIdDashboardAnnualCycleRoute
  '/$customerId/dashboard/lists': typeof HubCustomerIdDashboardListsRoute
  '/$customerId/dashboard': typeof HubCustomerIdDashboardIndexRoute
  '/$customerId/dashboard/$profileId/annual-cycle': typeof HubCustomerIdDashboardProfileIdAnnualCycleRoute
  '/$customerId/dashboard/$profileId/lists': typeof HubCustomerIdDashboardProfileIdListsRoute
  '/$customerId/dashboard/$profileId': typeof HubCustomerIdDashboardProfileIdIndexRoute
  '/$customerId/pulse/$pulseId': typeof HubCustomerIdPulsePulseIdIndexRoute
  '/$customerId/pulse/$pulseId/surveys': typeof HubCustomerIdPulsePulseIdSurveyListSurveysRoute
  '/$customerId/pulse/$pulseId/surveys/$surveyId/edit': typeof HubCustomerIdPulsePulseIdSurveysSurveyIdEditRoute
  '/$customerId/pulse/$pulseId/surveys/$surveyId': typeof HubCustomerIdPulsePulseIdSurveysSurveyIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_hub': typeof HubRouteRouteWithChildren
  '/legacy': typeof LegacyRoute
  '/_hub/$customerId': typeof HubCustomerIdRouteRouteWithChildren
  '/_hub/': typeof HubIndexRoute
  '/_hub/$customerId/dashboard': typeof HubCustomerIdDashboardRouteRouteWithChildren
  '/pulse/surveys/$participantId': typeof PulseSurveysParticipantIdRoute
  '/_hub/$customerId/': typeof HubCustomerIdIndexRoute
  '/_hub/$customerId/dashboard/$profileId': typeof HubCustomerIdDashboardProfileIdRouteRouteWithChildren
  '/_hub/$customerId/pulse/$pulseId': typeof HubCustomerIdPulsePulseIdRouteRouteWithChildren
  '/_hub/$customerId/dashboard/annual-cycle': typeof HubCustomerIdDashboardAnnualCycleRoute
  '/_hub/$customerId/dashboard/lists': typeof HubCustomerIdDashboardListsRoute
  '/_hub/$customerId/dashboard/': typeof HubCustomerIdDashboardIndexRoute
  '/_hub/$customerId/dashboard/$profileId/annual-cycle': typeof HubCustomerIdDashboardProfileIdAnnualCycleRoute
  '/_hub/$customerId/dashboard/$profileId/lists': typeof HubCustomerIdDashboardProfileIdListsRoute
  '/_hub/$customerId/dashboard/$profileId/': typeof HubCustomerIdDashboardProfileIdIndexRoute
  '/_hub/$customerId/pulse/$pulseId/': typeof HubCustomerIdPulsePulseIdIndexRoute
  '/_hub/$customerId/pulse/$pulseId/surveys/$surveyId': typeof HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRouteWithChildren
  '/_hub/$customerId/pulse/$pulseId/_surveyList/surveys': typeof HubCustomerIdPulsePulseIdSurveyListSurveysRoute
  '/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/edit': typeof HubCustomerIdPulsePulseIdSurveysSurveyIdEditRoute
  '/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/': typeof HubCustomerIdPulsePulseIdSurveysSurveyIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/legacy'
    | '/$customerId'
    | '/'
    | '/$customerId/dashboard'
    | '/pulse/surveys/$participantId'
    | '/$customerId/'
    | '/$customerId/dashboard/$profileId'
    | '/$customerId/pulse/$pulseId'
    | '/$customerId/dashboard/annual-cycle'
    | '/$customerId/dashboard/lists'
    | '/$customerId/dashboard/'
    | '/$customerId/dashboard/$profileId/annual-cycle'
    | '/$customerId/dashboard/$profileId/lists'
    | '/$customerId/dashboard/$profileId/'
    | '/$customerId/pulse/$pulseId/'
    | '/$customerId/pulse/$pulseId/surveys/$surveyId'
    | '/$customerId/pulse/$pulseId/surveys'
    | '/$customerId/pulse/$pulseId/surveys/$surveyId/edit'
    | '/$customerId/pulse/$pulseId/surveys/$surveyId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/legacy'
    | '/'
    | '/pulse/surveys/$participantId'
    | '/$customerId'
    | '/$customerId/dashboard/annual-cycle'
    | '/$customerId/dashboard/lists'
    | '/$customerId/dashboard'
    | '/$customerId/dashboard/$profileId/annual-cycle'
    | '/$customerId/dashboard/$profileId/lists'
    | '/$customerId/dashboard/$profileId'
    | '/$customerId/pulse/$pulseId'
    | '/$customerId/pulse/$pulseId/surveys'
    | '/$customerId/pulse/$pulseId/surveys/$surveyId/edit'
    | '/$customerId/pulse/$pulseId/surveys/$surveyId'
  id:
    | '__root__'
    | '/_hub'
    | '/legacy'
    | '/_hub/$customerId'
    | '/_hub/'
    | '/_hub/$customerId/dashboard'
    | '/pulse/surveys/$participantId'
    | '/_hub/$customerId/'
    | '/_hub/$customerId/dashboard/$profileId'
    | '/_hub/$customerId/pulse/$pulseId'
    | '/_hub/$customerId/dashboard/annual-cycle'
    | '/_hub/$customerId/dashboard/lists'
    | '/_hub/$customerId/dashboard/'
    | '/_hub/$customerId/dashboard/$profileId/annual-cycle'
    | '/_hub/$customerId/dashboard/$profileId/lists'
    | '/_hub/$customerId/dashboard/$profileId/'
    | '/_hub/$customerId/pulse/$pulseId/'
    | '/_hub/$customerId/pulse/$pulseId/surveys/$surveyId'
    | '/_hub/$customerId/pulse/$pulseId/_surveyList/surveys'
    | '/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/edit'
    | '/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  HubRouteRoute: typeof HubRouteRouteWithChildren
  LegacyRoute: typeof LegacyRoute
  PulseSurveysParticipantIdRoute: typeof PulseSurveysParticipantIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/legacy': {
      id: '/legacy'
      path: '/legacy'
      fullPath: '/legacy'
      preLoaderRoute: typeof LegacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_hub': {
      id: '/_hub'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof HubRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_hub/': {
      id: '/_hub/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof HubIndexRouteImport
      parentRoute: typeof HubRouteRoute
    }
    '/_hub/$customerId': {
      id: '/_hub/$customerId'
      path: '/$customerId'
      fullPath: '/$customerId'
      preLoaderRoute: typeof HubCustomerIdRouteRouteImport
      parentRoute: typeof HubRouteRoute
    }
    '/_hub/$customerId/': {
      id: '/_hub/$customerId/'
      path: '/'
      fullPath: '/$customerId/'
      preLoaderRoute: typeof HubCustomerIdIndexRouteImport
      parentRoute: typeof HubCustomerIdRouteRoute
    }
    '/pulse/surveys/$participantId': {
      id: '/pulse/surveys/$participantId'
      path: '/pulse/surveys/$participantId'
      fullPath: '/pulse/surveys/$participantId'
      preLoaderRoute: typeof PulseSurveysParticipantIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_hub/$customerId/dashboard': {
      id: '/_hub/$customerId/dashboard'
      path: '/dashboard'
      fullPath: '/$customerId/dashboard'
      preLoaderRoute: typeof HubCustomerIdDashboardRouteRouteImport
      parentRoute: typeof HubCustomerIdRouteRoute
    }
    '/_hub/$customerId/dashboard/': {
      id: '/_hub/$customerId/dashboard/'
      path: '/'
      fullPath: '/$customerId/dashboard/'
      preLoaderRoute: typeof HubCustomerIdDashboardIndexRouteImport
      parentRoute: typeof HubCustomerIdDashboardRouteRoute
    }
    '/_hub/$customerId/dashboard/lists': {
      id: '/_hub/$customerId/dashboard/lists'
      path: '/lists'
      fullPath: '/$customerId/dashboard/lists'
      preLoaderRoute: typeof HubCustomerIdDashboardListsRouteImport
      parentRoute: typeof HubCustomerIdDashboardRouteRoute
    }
    '/_hub/$customerId/dashboard/annual-cycle': {
      id: '/_hub/$customerId/dashboard/annual-cycle'
      path: '/annual-cycle'
      fullPath: '/$customerId/dashboard/annual-cycle'
      preLoaderRoute: typeof HubCustomerIdDashboardAnnualCycleRouteImport
      parentRoute: typeof HubCustomerIdDashboardRouteRoute
    }
    '/_hub/$customerId/pulse/$pulseId': {
      id: '/_hub/$customerId/pulse/$pulseId'
      path: '/pulse/$pulseId'
      fullPath: '/$customerId/pulse/$pulseId'
      preLoaderRoute: typeof HubCustomerIdPulsePulseIdRouteRouteImport
      parentRoute: typeof HubCustomerIdRouteRoute
    }
    '/_hub/$customerId/dashboard/$profileId': {
      id: '/_hub/$customerId/dashboard/$profileId'
      path: '/$profileId'
      fullPath: '/$customerId/dashboard/$profileId'
      preLoaderRoute: typeof HubCustomerIdDashboardProfileIdRouteRouteImport
      parentRoute: typeof HubCustomerIdDashboardRouteRoute
    }
    '/_hub/$customerId/pulse/$pulseId/': {
      id: '/_hub/$customerId/pulse/$pulseId/'
      path: '/'
      fullPath: '/$customerId/pulse/$pulseId/'
      preLoaderRoute: typeof HubCustomerIdPulsePulseIdIndexRouteImport
      parentRoute: typeof HubCustomerIdPulsePulseIdRouteRoute
    }
    '/_hub/$customerId/dashboard/$profileId/': {
      id: '/_hub/$customerId/dashboard/$profileId/'
      path: '/'
      fullPath: '/$customerId/dashboard/$profileId/'
      preLoaderRoute: typeof HubCustomerIdDashboardProfileIdIndexRouteImport
      parentRoute: typeof HubCustomerIdDashboardProfileIdRouteRoute
    }
    '/_hub/$customerId/dashboard/$profileId/lists': {
      id: '/_hub/$customerId/dashboard/$profileId/lists'
      path: '/lists'
      fullPath: '/$customerId/dashboard/$profileId/lists'
      preLoaderRoute: typeof HubCustomerIdDashboardProfileIdListsRouteImport
      parentRoute: typeof HubCustomerIdDashboardProfileIdRouteRoute
    }
    '/_hub/$customerId/dashboard/$profileId/annual-cycle': {
      id: '/_hub/$customerId/dashboard/$profileId/annual-cycle'
      path: '/annual-cycle'
      fullPath: '/$customerId/dashboard/$profileId/annual-cycle'
      preLoaderRoute: typeof HubCustomerIdDashboardProfileIdAnnualCycleRouteImport
      parentRoute: typeof HubCustomerIdDashboardProfileIdRouteRoute
    }
    '/_hub/$customerId/pulse/$pulseId/_surveyList/surveys': {
      id: '/_hub/$customerId/pulse/$pulseId/_surveyList/surveys'
      path: '/surveys'
      fullPath: '/$customerId/pulse/$pulseId/surveys'
      preLoaderRoute: typeof HubCustomerIdPulsePulseIdSurveyListSurveysRouteImport
      parentRoute: typeof HubCustomerIdPulsePulseIdRouteRoute
    }
    '/_hub/$customerId/pulse/$pulseId/surveys/$surveyId': {
      id: '/_hub/$customerId/pulse/$pulseId/surveys/$surveyId'
      path: '/surveys/$surveyId'
      fullPath: '/$customerId/pulse/$pulseId/surveys/$surveyId'
      preLoaderRoute: typeof HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRouteImport
      parentRoute: typeof HubCustomerIdPulsePulseIdRouteRoute
    }
    '/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/': {
      id: '/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/'
      path: '/'
      fullPath: '/$customerId/pulse/$pulseId/surveys/$surveyId/'
      preLoaderRoute: typeof HubCustomerIdPulsePulseIdSurveysSurveyIdIndexRouteImport
      parentRoute: typeof HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRoute
    }
    '/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/edit': {
      id: '/_hub/$customerId/pulse/$pulseId/surveys/$surveyId/edit'
      path: '/edit'
      fullPath: '/$customerId/pulse/$pulseId/surveys/$surveyId/edit'
      preLoaderRoute: typeof HubCustomerIdPulsePulseIdSurveysSurveyIdEditRouteImport
      parentRoute: typeof HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRoute
    }
  }
}

interface HubCustomerIdDashboardProfileIdRouteRouteChildren {
  HubCustomerIdDashboardProfileIdAnnualCycleRoute: typeof HubCustomerIdDashboardProfileIdAnnualCycleRoute
  HubCustomerIdDashboardProfileIdListsRoute: typeof HubCustomerIdDashboardProfileIdListsRoute
  HubCustomerIdDashboardProfileIdIndexRoute: typeof HubCustomerIdDashboardProfileIdIndexRoute
}

const HubCustomerIdDashboardProfileIdRouteRouteChildren: HubCustomerIdDashboardProfileIdRouteRouteChildren =
  {
    HubCustomerIdDashboardProfileIdAnnualCycleRoute:
      HubCustomerIdDashboardProfileIdAnnualCycleRoute,
    HubCustomerIdDashboardProfileIdListsRoute:
      HubCustomerIdDashboardProfileIdListsRoute,
    HubCustomerIdDashboardProfileIdIndexRoute:
      HubCustomerIdDashboardProfileIdIndexRoute,
  }

const HubCustomerIdDashboardProfileIdRouteRouteWithChildren =
  HubCustomerIdDashboardProfileIdRouteRoute._addFileChildren(
    HubCustomerIdDashboardProfileIdRouteRouteChildren,
  )

interface HubCustomerIdDashboardRouteRouteChildren {
  HubCustomerIdDashboardProfileIdRouteRoute: typeof HubCustomerIdDashboardProfileIdRouteRouteWithChildren
  HubCustomerIdDashboardAnnualCycleRoute: typeof HubCustomerIdDashboardAnnualCycleRoute
  HubCustomerIdDashboardListsRoute: typeof HubCustomerIdDashboardListsRoute
  HubCustomerIdDashboardIndexRoute: typeof HubCustomerIdDashboardIndexRoute
}

const HubCustomerIdDashboardRouteRouteChildren: HubCustomerIdDashboardRouteRouteChildren =
  {
    HubCustomerIdDashboardProfileIdRouteRoute:
      HubCustomerIdDashboardProfileIdRouteRouteWithChildren,
    HubCustomerIdDashboardAnnualCycleRoute:
      HubCustomerIdDashboardAnnualCycleRoute,
    HubCustomerIdDashboardListsRoute: HubCustomerIdDashboardListsRoute,
    HubCustomerIdDashboardIndexRoute: HubCustomerIdDashboardIndexRoute,
  }

const HubCustomerIdDashboardRouteRouteWithChildren =
  HubCustomerIdDashboardRouteRoute._addFileChildren(
    HubCustomerIdDashboardRouteRouteChildren,
  )

interface HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRouteChildren {
  HubCustomerIdPulsePulseIdSurveysSurveyIdEditRoute: typeof HubCustomerIdPulsePulseIdSurveysSurveyIdEditRoute
  HubCustomerIdPulsePulseIdSurveysSurveyIdIndexRoute: typeof HubCustomerIdPulsePulseIdSurveysSurveyIdIndexRoute
}

const HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRouteChildren: HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRouteChildren =
  {
    HubCustomerIdPulsePulseIdSurveysSurveyIdEditRoute:
      HubCustomerIdPulsePulseIdSurveysSurveyIdEditRoute,
    HubCustomerIdPulsePulseIdSurveysSurveyIdIndexRoute:
      HubCustomerIdPulsePulseIdSurveysSurveyIdIndexRoute,
  }

const HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRouteWithChildren =
  HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRoute._addFileChildren(
    HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRouteChildren,
  )

interface HubCustomerIdPulsePulseIdRouteRouteChildren {
  HubCustomerIdPulsePulseIdIndexRoute: typeof HubCustomerIdPulsePulseIdIndexRoute
  HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRoute: typeof HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRouteWithChildren
  HubCustomerIdPulsePulseIdSurveyListSurveysRoute: typeof HubCustomerIdPulsePulseIdSurveyListSurveysRoute
}

const HubCustomerIdPulsePulseIdRouteRouteChildren: HubCustomerIdPulsePulseIdRouteRouteChildren =
  {
    HubCustomerIdPulsePulseIdIndexRoute: HubCustomerIdPulsePulseIdIndexRoute,
    HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRoute:
      HubCustomerIdPulsePulseIdSurveysSurveyIdRouteRouteWithChildren,
    HubCustomerIdPulsePulseIdSurveyListSurveysRoute:
      HubCustomerIdPulsePulseIdSurveyListSurveysRoute,
  }

const HubCustomerIdPulsePulseIdRouteRouteWithChildren =
  HubCustomerIdPulsePulseIdRouteRoute._addFileChildren(
    HubCustomerIdPulsePulseIdRouteRouteChildren,
  )

interface HubCustomerIdRouteRouteChildren {
  HubCustomerIdDashboardRouteRoute: typeof HubCustomerIdDashboardRouteRouteWithChildren
  HubCustomerIdIndexRoute: typeof HubCustomerIdIndexRoute
  HubCustomerIdPulsePulseIdRouteRoute: typeof HubCustomerIdPulsePulseIdRouteRouteWithChildren
}

const HubCustomerIdRouteRouteChildren: HubCustomerIdRouteRouteChildren = {
  HubCustomerIdDashboardRouteRoute:
    HubCustomerIdDashboardRouteRouteWithChildren,
  HubCustomerIdIndexRoute: HubCustomerIdIndexRoute,
  HubCustomerIdPulsePulseIdRouteRoute:
    HubCustomerIdPulsePulseIdRouteRouteWithChildren,
}

const HubCustomerIdRouteRouteWithChildren =
  HubCustomerIdRouteRoute._addFileChildren(HubCustomerIdRouteRouteChildren)

interface HubRouteRouteChildren {
  HubCustomerIdRouteRoute: typeof HubCustomerIdRouteRouteWithChildren
  HubIndexRoute: typeof HubIndexRoute
}

const HubRouteRouteChildren: HubRouteRouteChildren = {
  HubCustomerIdRouteRoute: HubCustomerIdRouteRouteWithChildren,
  HubIndexRoute: HubIndexRoute,
}

const HubRouteRouteWithChildren = HubRouteRoute._addFileChildren(
  HubRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  HubRouteRoute: HubRouteRouteWithChildren,
  LegacyRoute: LegacyRoute,
  PulseSurveysParticipantIdRoute: PulseSurveysParticipantIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
